
import { Options, Vue } from "vue-class-component";
import { compare, dateConversion, getLocalProject, unique_json } from "@/utils";
import * as echarts from "echarts";
import {
  dispatchDataValid,
  dispatchGetPerformancePageList,
  dispatchGetPerformances,
  dispatchGetPerformanceSelectOptions,
  dispatchGetPerformanceTableFields,
} from "@/store/performance/actions";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import { store } from "@/store";
import {
  readPerformancePageList,
  readPerformances,
  readPerformanceSelectOptions,
  readPerformanceTableFields,
} from "@/store/performance/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetProjectScenes } from "@/store/project/actions";
import { readMyProjects, readProjectScenes } from "@/store/project/getters";
import { readUserProfile } from "@/store/main/getters";
@Options({
  components: {
    SideMenu,
  },
})
export default class PerformanceChart extends Vue {
  public localProject = Number(getLocalProject());

  public loading = false;
  public table_loading = false;
  public selected_scene =
    readPerformanceSelectOptions(store).scene_list[0]?.scene_id || "";
  public selected_device =
    this.all_device_echart_options.map((item) => item.value) || [];
  public selected_target = "avg_fps";
  public selected_table_scene = this.scene_options.map((item) => item.scene_id);
  public selected_table_device = this.all_device_options.map(
    (item) => item.value
  );
  public selected_table_version = this.game_version_options.map(
    (item) => item.value
  );
  public current_page = 1;

  public async mounted() {
    this.loading = true;
    this.table_loading = true;
    dispatchGetPerformanceTableFields(store, { project: this.localProject });
    await dispatchGetProjectScenes(store, { project: this.localProject });
    await dispatchGetPerformanceSelectOptions(store, {
      project: this.localProject,
    });
    this.selected_scene =
      readPerformanceSelectOptions(store).scene_list[0]?.scene_id || "";
    await dispatchGetPerformances(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id:
        readPerformanceSelectOptions(store).scene_list[0]?.scene_id || "",
      device_id: "",
    });
    await dispatchGetDeviceSpecs(store, { project: this.localProject });
    await this.drawPieChart;
    this.onClear();
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: 1,
      size: 16,
      custom_versions: "",
    });
    this.table_loading = false;
    this.onTableAll();
    this.loading = false;
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  public get performance_table_fields() {
    const beford_fields = [
      { label: "场景名称", prop: "scene_chinese", width: "105" },
      { label: "设备", prop: "device_name", width: "120" },
      { label: "版本", prop: "game_version", width: "96" },
    ];
    const after_fields = [
      { label: "测试时间", prop: "timestamp", width: "150" },
      { label: "耗时", prop: "duration", width: "96" },
    ];
    const performance_table_fields = readPerformanceTableFields(store);
    let performance_fields = [];
    performance_fields.push(...beford_fields);
    for (var key in performance_table_fields) {
      performance_fields.push({
        label: performance_table_fields[key],
        prop: key,
      });
    }
    performance_fields.push(...after_fields);
    return performance_fields;
  }

  public get getPerformances() {
    const performances: any[] = readPerformances(store);
    return performances;
  }

  public get getPerformancePageList() {
    return readPerformancePageList(store);
  }

  public get get_table_data() {
    let data = this.getPerformancePageList;
    data.results.forEach((item: any) => {
      item.timestamp = dateConversion(item.timestamp);
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item.device_id
      )[0];
      item.scene_chinese = this.getScenes.filter(
        (scene: any) => scene.id === item.scene_id
      )[0]?.chinese;
      item.device_name = device?.level + "档机 - " + device?.remark;
    });

    return data;
  }

  public get getDeviceSpecs() {
    const devices = readDeviceSpecs(store);
    return devices;
  }

  public get getScenes() {
    const scenes = readProjectScenes(store);
    return scenes;
  }

  public get getPerformanceSelectOptions() {
    return readPerformanceSelectOptions(store);
  }

  public get scene_options() {
    const scene_list: any[] = this.getPerformanceSelectOptions.scene_list;
    scene_list.forEach((scene) => {
      let chinese = this.getScenes.filter(
        (item: any) => item.id === Number(scene.scene_id)
      )[0]?.chinese;
      scene.chinese = chinese;
    });
    return scene_list.sort(compare("count"));
  }

  public get all_device_echart_options() {
    const devices = unique_json(this.getPerformances, "device_id");
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item.device_id
      )[0];
      const name =
        device?.level +
        "档机 - " +
        device?.remark +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item.device_id,
        level: device?.level,
      });
    });
    return device_select;
  }

  public get device_echart_options() {
    const devices = unique_json(this.getPerformances, "device_id");
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item.device_id
      )[0];
      const name =
        device?.level +
        "档机 - " +
        device?.remark +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item.device_id,
        level: device?.level,
      });
    });

    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < device_select.length; i++) {
      let ai = device_select[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }
    return dest.sort(compare("level"));
  }

  public get device_options() {
    const devices = this.getPerformanceSelectOptions.device_list;
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];
      const name =
        device?.level +
        "档机 - " +
        device?.remark +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
        level: device?.level,
      });
    });
    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < device_select.length; i++) {
      let ai = device_select[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }
    return dest.sort(compare("level"));
  }

  public get all_device_options() {
    const devices = this.getPerformanceSelectOptions.device_list;
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];
      const name =
        device?.level +
        "档机 - " +
        device?.remark +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
      });
    });
    return device_select;
  }

  public get game_version_options() {
    const versions = this.getPerformanceSelectOptions.game_versions;
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item) {
        game_version_select.push({
          label: item,
          value: item,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return unique_json(game_version_select, "value");
  }

  public get target_types() {
    const target_select = [
      {
        label: "平均FPS",
        value: "avg_fps",
      },
      {
        label: "峰值PSS",
        value: "max_pss",
      },
      {
        label: "峰值Used Mono",
        value: "max_mono_used",
      },
      {
        label: "峰值Total Mono",
        value: "max_mono_total",
      },
      {
        label: "平均CPU",
        value: "avg_cpu",
      },
      {
        label: "平均DC",
        value: "avg_dc",
      },
      {
        label: "峰值DC",
        value: "max_dc",
      },
      {
        label: "峰值三角形(万)",
        value: "max_triangle",
      },
      {
        label: "GC次数",
        value: "gc_cnt",
      },
    ];
    return target_select;
  }

  public get drawPieChart() {
    // 场景过滤
    let performances: any[] = [];
    performances = this.getPerformances.filter(
      (item) => item.game_version !== "" && item.game_version !== null
    );

    // 设备过滤
    performances = performances.filter((item) =>
      this.selected_device.includes(item.device_id)
    );

    // 横坐标
    const game_versions = unique_json(performances, "game_version")
      .map((item) => item.game_version)
      .sort();
    // 纵坐标
    const devices = unique_json(performances, "device_id");
    // 数据
    const ordinates: any[] = [];

    // 初始化数据
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item.device_id
      )[0];
      ordinates.push({
        name:
          device?.level + "档机 - " + device?.remark + " - " + device?.model,
        id: item.device_id,
        type: "bar",
        data: [],
        cache: [],
      });
    });

    // cache里存放的是完整的数据，但已经按照设备过滤
    ordinates.forEach((device) => {
      performances.forEach((item) => {
        if (item.device_id === device.id) {
          device.cache.push(item);
        }
      });
    });

    // 纵坐标填充值，将没有数据的横坐标节点填充为空,eg：[1, 2, 3, 4, 6] => [1, 2 , 3, 4, "", 6]
    ordinates.forEach((device) => {
      game_versions.forEach((version) => {
        const item = (device.cache as any[]).filter(
          (item) => item.game_version === version
        )[0]?.[this.selected_target];
        if (item || item === 0 || item === "0") {
          device.data.push(item);
        } else {
          device.data.push("");
        }
      });
    });

    let performance_line: any = document.getElementById("performance_line");

    // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
    // echarts数据变动时, 数据正常，图标混乱，故以此解决
    echarts.dispose(performance_line);

    let PerformanceLineChart = echarts.init(performance_line);
    let option;

    option = {
      title: {
        text: "性能趋势图",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        type: "scroll",
        width: "75%",
        data: devices.map(
          (item) =>
            this.getDeviceSpecs.filter(
              (device) => device.id === item.device_id
            )[0]?.level +
            "档机 - " +
            this.getDeviceSpecs.filter(
              (device) => device.id === item.device_id
            )[0]?.remark +
            " - " +
            this.getDeviceSpecs.filter(
              (device) => device.id === item.device_id
            )[0]?.model?.model
        ),
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
          magicType: { show: true, type: ["line", "bar"] },
        },
      },
      xAxis: {
        type: "category",
        // boundaryGap: false,
        data: game_versions,
      },
      yAxis: {
        type: "value",
      },
      series: ordinates,
    };
    PerformanceLineChart.setOption(option);
    return PerformanceLineChart;
  }

  public async onClear() {
    this.loading = true;
    await dispatchGetPerformances(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id:
        readPerformanceSelectOptions(store).scene_list[0]?.scene_id || "",
      device_id: "",
    });
    this.selected_scene = this.scene_options[0]?.scene_id || "";
    this.selected_device =
      this.all_device_echart_options.map((item) => item.value) || [];
    this.selected_target = "avg_fps";
    this.drawPieChart;
    this.loading = false;
  }

  public async onTableClear() {
    this.table_loading = true;
    this.selected_table_scene = [];
    this.selected_table_device = [];
    this.selected_table_version = [];

    this.current_page = 1;
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: 1,
      size: 16,
      custom_versions: "",
    });
    this.table_loading = false;
  }

  public async onTableAll() {
    this.table_loading = true;
    this.selected_table_scene = this.scene_options.map((item) => item.scene_id);
    this.selected_table_device = this.all_device_options.map(
      (item) => item.value
    );
    this.selected_table_version = this.game_version_options.map(
      (item) => item.value
    );

    this.current_page = 1;
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: 1,
      size: 16,
      custom_versions: "",
    });
    this.table_loading = false;
  }

  public async selectSceneChange() {
    this.loading = true;
    await dispatchGetPerformances(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id: this.selected_scene,
      device_id: "",
    });
    this.drawPieChart;
    this.loading = false;
  }

  public async selectTableChange() {
    this.table_loading = true;
    this.current_page = 1;
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: this.current_page,
      size: 16,
      custom_versions: "",
    });
    this.table_loading = false;
  }

  public selectChange() {
    this.drawPieChart;
  }

  public async handleCurrentChange() {
    this.table_loading = true;
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: this.current_page,
      size: 16,
      custom_versions: "",
    });
    this.table_loading = false;
  }

  public async handleSelectAll() {
    this.selected_device =
      this.all_device_echart_options.map((item) => item.value) || [];
    this.drawPieChart;
  }

  public async handleClearAll() {
    this.selected_device = [];
    this.drawPieChart;
  }

  // 全选某个选择器, name: 选择器标识
  public async handleSelectTableAll(name: string) {
    this.table_loading = true;
    if (name === "selected_table_scene") {
      this.selected_table_scene = this.scene_options.map(
        (item) => item.scene_id
      );
    } else if (name === "selected_table_device") {
      this.selected_table_device = this.all_device_options.map(
        (item) => item.value
      );
    } else {
      this.selected_table_version = this.game_version_options.map(
        (item) => item.value
      );
    }
    this.current_page = 1;
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: 1,
      size: 16,
      custom_versions: "",
    });
    this.table_loading = false;
  }

  // 清除某个选择器, name: 选择器标识
  public async handleClearTableAll(name: string) {
    this.table_loading = true;
    (this as any)[name] = [];

    this.current_page = 1;
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: 1,
      size: 16,
      custom_versions: "",
    });
    this.table_loading = false;
  }

  public async IsValidChange(row: any) {
    this.table_loading = true;
    const upload_data = {
      id: row.id,
      is_valid: row.is_valid,
      task_group_index: row.task_group_index,
      device_id: row.device_id,
      task_record_id: row.task_record_id,
      script_id: row.script_id,
      scene_id: row.scene_id,
      project: row.project,
    };
    await dispatchDataValid(store, {
      id: row.id,
      project: row.project,
      data: upload_data,
    });
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: this.current_page,
      size: 16,
      custom_versions: "",
    });
    this.table_loading = false;
  }

  public fixed = false;

  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }
}
